import * as React from "react";
import CustomFieldsView from "./CustomFieldsView";
import CustomField from "../../../model/customField/CustomField";
import {Dispatch} from "redux";
import {createLeadCustomField, fetchLeadCustomFields, updateLeadCustomField} from "../../../store/action/customField/customField";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {RootState} from "../../../store/reducer/root/RootState";
import {Option} from "ts-option";
import {connect} from "react-redux";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";
import Toast from "../../helper/Toast";

interface IDispatchProps {
	/**
	 * Fetch lead custom fields method
	 */
	fetchLeadCustomFields: () => void;
	/**
	 * Create lead custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	createLeadCustomField: (customField: CustomField, onSuccess: OnSuccessData<CustomField>, onFailure: OnFailure) => void;
	/**
	 * Update lead custom field.
	 * @param {CustomField} customField
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateLeadCustomField: (customField: CustomField, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface ReduxProps {
	/**
	 * Lead custom fields list.
	 */
	leadCustomFields: Option<CustomField[]>;
}

type Props = IDispatchProps & ReduxProps;

class LeadCustomFieldsView extends React.Component<Props> {
	render() {
		return (
			<CustomFieldsView fetchCustomFields={this.props.fetchLeadCustomFields}
							  createCustomField={this.createLeadCustomField}
							  updateCustomField={this.updateLeadCustomField}
							  pageTitle={'Lead custom fields'}
							  customFields={this.props.leadCustomFields}
							  noDataText={'No lead custom fields'}/>
		);
	}

	createLeadCustomField = (customField: CustomField,
		onSuccess: OnSuccessData<CustomField>,
		onFailure: OnFailure) =>
		this.props.createLeadCustomField(customField,
			(customField) => {
				onSuccess(customField);
				Toast.success("Lead custom field created", "Lead custom field create");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Lead custom field creation failed");
			}
		);

	updateLeadCustomField = (customField: CustomField,
		onSuccess: OnSuccess,
		onFailure: OnFailure) =>
		this.props.updateLeadCustomField(customField,
			() => {
				onSuccess();
				Toast.success("Lead custom field updated", "Lead custom field update");
			},
			(err) => {
				onFailure(err);
				notifyBugsnagAndShowToast(err, "Lead custom field update failed");
			}
		);
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchLeadCustomFields: () => dispatch(
			fetchLeadCustomFields(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch lead custom fields"))
		),
		createLeadCustomField: (customField: CustomField, onSuccess: OnSuccessData<CustomField>, onFailure: OnFailure) => {
			dispatch(createLeadCustomField(customField, onSuccess, onFailure))
		},
		updateLeadCustomField: (customField: CustomField, onSuccess: OnSuccess, onFailure: OnFailure) => {
			dispatch(updateLeadCustomField(customField, onSuccess, onFailure))
		}
	};
}

function mapStateToProps(state: RootState) {
	return {
		leadCustomFields: state.customFields.leadCustomFields,
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(LeadCustomFieldsView)